import React, { useState } from "react";
import { getDatabase, ref, set, update, remove } from "firebase/database";
import { VscCheck } from "react-icons/vsc";
import { VscClose } from "react-icons/vsc";
import { VscTrash } from "react-icons/vsc";
import AddQuestionComponent from "./AddQuestionComponent";

import Modal from "react-modal";

import "./QuizComponent.css";

const QuizComponent = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [newQuestionModalIsOpen, setNewQuestionModalIsOpen] = useState(false);

  // for quiz record
  const [quizDbName, setQuizDbName] = useState(props.quiz);
  const [name, setName] = useState(props.name);
  const [passingScore, setPassingScore] = useState(props.passingScore);
  const [questions, setQuestions] = useState(props.questions);
  const [description, setDescription] = useState(props.description);
  const [category, setCategory] = useState(props.category);
  const [averageRating, setAverageRating] = useState(props.averageRating);
  const [live, setLive] = useState(props.live);
  const [questionsPerEntry, setQuestionsPerEntry] = useState(
    props.questionsPerEntry
  );
  const [timesTaken, setTimesTaken] = useState(props.timesTaken);
  const [imageURL, setImageURL] = useState(props.imageUrl);

  const [inputFieldsError, setInputFieldsError] = useState("");

  const trueFalseNull = (value) => {
    if (value == null) {
      return 0;
    }

    if (value == true) {
      return "true";
    } else {
      return "false";
    }
  };

  const emptyInputStringsValidation = () => {
    return (
      quizDbName != "" &&
      name != "" &&
      passingScore != "" &&
      questions.length >= 1 &&
      questions[0] != "" && // adittion list emptity check
      description != "" &&
      category != "" &&
      averageRating != "" &&
      live.toString() != "" &&
      questionsPerEntry != "" &&
      timesTaken != "" &&
      imageURL != ""
    );
  };

  const updateQuiz = (
    name,
    passingScore,
    questions,
    description,
    category,
    averageRating,
    live,
    questionsPerEntry,
    timesTaken,
    imageURL
  ) => {
    const db = getDatabase();
    const postData = {
      name: name,
      category: parseFloat(category),
      description: description,
      questions: questions,
      passingScore: parseFloat(passingScore),
      averageRating: parseFloat(averageRating),
      live: live.toString().toLowerCase() === "true",
      questionsPerEntry: parseFloat(questionsPerEntry),
      timesTaken: parseFloat(timesTaken),
      imageURL: imageURL,
    };
    if (emptyInputStringsValidation()) {
      update(ref(db, "quizzes/" + props.quiz), postData);
      setInputFieldsError(emptyInputStringsValidation());
      setModalIsOpen(false);

    } else {
      setInputFieldsError(emptyInputStringsValidation());
    }
  };

  const removeQuiz = () => {
    const db = getDatabase();
    remove(ref(db, "quizzes/" + props.quiz));
    setModalIsOpen(false);
    window.location.reload() // temp fix (think how to reload list on adding new quiz (in QuestionsList it works))
  };

  return (
    <div>


      <Modal
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          },
          content: {
            position: "absolute",

            width: "30%",
            height: "80%",

            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "15px",
            outline: "none",
            padding: "35px",
            paddingLeft: "45px",

            border: "0",
            bottom: "auto",
            minHeight: "10rem",
            left: "50%",
            position: "fixed",
            right: "auto",
            top: "50%",
            transform: "translate(-50%,-50%)",
            minWidth: "20rem",
            maxWidth: "60rem",
          },
        }}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        closeTimeoutMS={200}
      >
        <div className="quiz-component-modal-body">
          <div className="quiz-component-modal-input-fields">
            <div className="modal-title">
              <h1>Quiz ID: {quizDbName}</h1>
              <button
                className="close-modal-btn"
                onClick={() => setModalIsOpen(false)}
              >
                <VscClose size={"20px"} color="grey" />
              </button>
            </div>

            <input
              className="modal-input"
              placeholder="Name"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Passing Score"
              value={passingScore}
              onChange={(e) => {
                setPassingScore(e.target.value);
              }}
            />
            <div>

            <input
              className="modal-input"
              placeholder="Questions"
              value={questions?.join(", ")}
              onChange={(e) => {
                setQuestions(e.target.value.split(", "));
              }}
              />
              {/* <button onClick={() => setNewQuestionModalIsOpen(true)}>Add question</button> */}

              </div>
            <input
              className="modal-input"
              placeholder="Description"
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Category"
              value={category}
              onChange={(e) => {
                setCategory(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Average Rating"
              value={averageRating}
              onChange={(e) => {
                setAverageRating(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Live"
              value={live}
              onChange={(e) => {
                setLive(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Questions per Entry"
              value={questionsPerEntry}
              onChange={(e) => {
                setQuestionsPerEntry(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Times Taken"
              value={timesTaken}
              onChange={(e) => {
                setTimesTaken(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Image URL"
              value={imageURL}
              onChange={(e) => {
                setImageURL(e.target.value);
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            marginTop: "8%",
            alignItems: "center",
            justifyContent: "space-between",
            marginRight: "7%",
          }}
        >
          <button
            className="submit-button"
            onClick={() =>
              updateQuiz(
                name,
                passingScore,
                questions,
                description,
                category,
                averageRating,
                live,
                questionsPerEntry,
                timesTaken,
                imageURL
              )
            }
          >
            Update Quiz
          </button>

          <button
            style={{ background: "none", border: "none", cursor: "pointer" }}
            onClick={() => removeQuiz()}
          >
            <VscTrash color="red" size={20} />
          </button>
        </div>
      </Modal>

      {/* Add question modal */}
      <Modal
        closeTimeoutMS={200}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          },
          content: {
            position: "absolute",

            width: "30%",
            height: "80%",

            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "15px",
            outline: "none",
            padding: "35px",
            paddingLeft: "45px",

            border: "0",
            bottom: "auto",
            minHeight: "10rem",
            left: "50%",
            position: "fixed",
            right: "auto",
            top: "50%",
            transform: "translate(-50%,-50%)",
            minWidth: "20rem",
            maxWidth: "60rem",
          },
        }}
        isOpen={newQuestionModalIsOpen}
        onRequestClose={() => setNewQuestionModalIsOpen(false)}
      >
        <AddQuestionComponent setModalIsOpen={setNewQuestionModalIsOpen} questions={questions} setQuestions={setQuestions} inQuiz={true}/>
      </Modal>
      
      <div className="quiz-component" onClick={() => setModalIsOpen(true)}>
        <div className="quiz-component-name">
          {props.name != null ? props.name : 0}
        </div>
        <div className="quiz-component-quiz">
          {props.quiz != null ? props.quiz : 0}
        </div>
        <div className="quiz-component-passing-score">
          {props.passingScore != null ? props.passingScore : 0}
        </div>
        <div className="quiz-component-questions">
          {props.questions != null
            ? props.questions.map((question) => <li>{question}</li>)
            : 0}
        </div>
        <div className="quiz-component-description">
          {props.description != null ? props.description : 0}
        </div>
        <div className="quiz-component-category">
          {props.category != null ? props.category : 0}
        </div>
        <div className="quiz-component-average-rating">
          {props.averageRating != null ? props.averageRating : 0}
        </div>
        <div className="quiz-component-live">
          {props.live ? (
            <VscCheck color="green" size={17} />
          ) : (
            <VscClose color="red" size={17} />
          )}
        </div>
        <div className="quiz-component-questions-per-entry">
          {props.questionsPerEntry != null ? props.questionsPerEntry : 0}
        </div>
        <div className="quiz-component-times-taken">
          {props.timesTaken != null ? props.timesTaken : 0}
        </div>
        <div className="quiz-component-image-url">
          {props.imageUrl != null ? (
            <VscCheck color="green" size={17} />
          ) : (
            <VscClose color="red" size={17} />
          )}
        </div>
      </div>
    </div>
  );
};

export default QuizComponent;
